import axios, { AxiosError } from "axios";
import { url } from ".";
import { LogParam } from "../types/logParam";
import { logError, logInfo } from "../utils/logger";
import { errorMessage } from "../utils/common";
import { cookies } from "../utils/cookies";

const logParams: LogParam = {
  applicationName: "Orchestrator Client",
  screenModuleName: "client\\src\\controllers\\bots.ts",
  functionName: "",
  message: "",
};

export const getLatestVersion = () =>
  axios
    .get(`${url}/getLatestVersion`, {})
    .then((res) => {
      logParams.functionName = "getLatestVersion";
      logParams.message = `getting Agent/Studio latest version"`;
      logInfo(logParams);

      return res.data;
    })
    .catch((error) => {
      logParams.functionName = "getLatestVersion";
      logParams.message = errorMessage(error);
      logError(logParams);
    });

export const getOrchestratorURL = () =>
  axios
    .get(`${url}/getOrchestratorURL`, {})
    .then((res) => {
      logParams.functionName = "getOrchestratorURL";
      logParams.message = `getting Orchestrator URL"`;
      logInfo(logParams);

      return res.data;
    })
    .catch((error) => {
      logParams.functionName = "getOrchestratorURL";
      logParams.message = errorMessage(error);
      logError(logParams);
    });

export const apiUnauthLogout = (
  _error: AxiosError<{ message: string }>,
  functionName: string
) => {
  let errorMsg = "An unexpected error occurred.";
  logParams.functionName = `apiUnauthLogout : ${functionName}`;
  logParams.message = errorMsg;
  logError(logParams);

  cookies.remove("token");
  sessionStorage.clear();

  window.location.href = "/login";
};
